<template>
  <div class="accountMar">
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="float: left;">
        <span style="line-height: 36px;">提现总金额：</span>
        <span style="line-height: 36px;color:#4db3ff;">{{(totalMoney/100).toFixed(2)}}</span>
      </span>
      <span style="float: left;margin-left:10px;">
        <span style="line-height: 36px;">已付款：</span>
        <span style="line-height: 36px;color:#4db3ff;">{{(alreadyMoney/100).toFixed(2)}}</span>
      </span>
      <span style="float: left;margin-left:10px;">
        <span style="line-height: 36px;">待付款：</span>
        <span style="line-height: 36px;color:#4db3ff;">{{(waitMoney/100).toFixed(2)}}</span>
      </span>

      <span style="float: left;margin-left:10px;">
        <el-input placeholder="提现账号" v-model="searchValue" @keyup.enter.native="btnQueryAccountByKey"
        style="width:200px;">
         
          <el-button slot="append" icon="search" @click="btnQueryAccountByKey"></el-button>
        </el-input></span>
      <span style="line-height: 36px;">审核记录</span>
    </div>
    <div>
      <el-table
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="tableData"
      stripe
      border
      fit
      style="width: 100%">
      <el-table-column
        prop="account"
        header-align="center"
        min-width="120"        
        label="账号">
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        min-width="100"        
        label="名称">
      </el-table-column>
      <el-table-column
        prop="money"
        header-align="center"
        min-width="80"
        label="金额">
      </el-table-column>
      <el-table-column
        prop="bankType"
        header-align="center"
        min-width="100"
        label="银行类型">
      </el-table-column>
      <el-table-column
        prop="bankName"
        header-align="center"
        min-width="120"
        label="银行账户名">
      </el-table-column>
      <el-table-column
        prop="bankNum"
        header-align="center"
        min-width="200"
        label="银行卡号">
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        min-width="160"
        label="创建时间">
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        min-width="95"
        label="状态">
        <template scope="scope">
        <el-tag :type="scope.row.status === '已提现' ? 'success' : (scope.row.status === '申请中' ? 'warning' : 'danger')"
        close-transition>{{scope.row.status}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="see"
        header-align="center"
        min-width="100"
        label="操作">
        <template scope="scope">
            <el-button 
                @click="check(1,scope.row.id)"
                type="text" size="small" v-if="scope.row.status == '申请中'">
                通过
            </el-button>
            <el-button 
                style="color: #FF4949"
                @click="check(2,scope.row.id)"
                type="text" size="small" v-if="scope.row.status == '申请中'">
                拒绝
            </el-button>
            <el-button 
                @click="check(2,scope.row.id)"
                type="text" size="small"
                disabled
                v-if="scope.row.status != '申请中'">
                已审核
            </el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>
  </div>
</template>

 <script>
    import $axios from '../../https/config'
    // import {isNull} from '../../js/tool'

    export default {
      data () {
        return {
          tableData: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          userType: this.$store.state.userType,
          table_loading: false,
          addAccountShow: false,
          updatePwdShow: false,
          userNum: '',
          searchValue: '',
          searchSelect: '-1',
          totalMoney: 0,
          alreadyMoney: 0,
          waitMoney: 0,
          // searchValue:""
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryRecordList(this.pageNo, this.pageSize)
      },
      methods: {
        btnQueryAccountByKey( ){
          this.pageNo = 1;
          this.queryRecordList(this.pageNo, this.pageSize);
        },

        queryRecordList (tPageNo, tPageSize) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            key: _this.searchValue,
          }
          this.table_loading = true
          this.tableData = []
          $axios.get('/withdraw/list', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData) {
                _this.pageTotal = res.resultData.count
                _this.totalMoney = res.resultData.totalAmount
                _this.alreadyMoney = res.resultData.isPayAmount
                _this.waitMoney = res.resultData.notPayAmount
                if (res.resultData.list) {
                  for (var i = 0; i < res.resultData.list.length; i++) {
                    var itemData = res.resultData.list[i]
                    var item = {
                      id: itemData.withdraw_id,
                      account: itemData.username,
                      bankName: itemData.bank_account_name,
                      bankType: itemData.bank_name,
                      bankNum: itemData.bank_card,
                      name: itemData.nickname,
                      money: (itemData.amount / 100).toFixed(2),
                      status: itemData.status === 0 ? '申请中' : itemData.status === 1 ? '已提现' : '拒绝',
                      createTime: new Date(itemData.create_time).getFullYear() + '-' + (new Date(itemData.create_time).getMonth() + 1) + '-' + new Date(itemData.create_time).getDate()
                    }
                    resData.push(item)
                  }
                }
                _this.tableData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },
        handleSizeChange (val) {
          this.pageSize = val
          if (this.searchSelect === '-1') {
            this.queryRecordList(this.pageNo, this.pageSize)
          } else {
            this.queryRecordList(this.pageNo, this.pageSize)
          }
        },
        handleCurrentChange (val) {
          this.pageNo = val
          if (this.searchSelect === '-1') {
            this.queryRecordList(this.pageNo, this.pageSize)
          } else {
            this.queryRecordList(this.pageNo, this.pageSize)
          }
        },
        check (type, id) {
          var msg = type === 1 ? '通过' : '拒绝'
          this.$confirm('确认' + msg + '该审核？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: type === 1 ? 'success' : 'error',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                var _this = this
                var params = {
                  withdraw_id: id,
                  status: type,
                  withdraw_reason: '无原因'
                }
                var url = '/withdraw/check'
                $axios.post(url, params, 'headers', function (res) {
                  done()
                  if (res.resultStatus) {
                    _this.$message({
                      type: 'success',
                      message: msg + '该审核'
                    })
                    _this.queryRecordList(_this.pageNo, _this.pageSize)
                  } else {
                    _this.$message({
                      message: '操作失败' + res.errorMessage,
                      type: 'error'
                    })
                  }
                }, function (err) {
                  done()
                  _this.loading = false
                  _this.$message({
                    type: 'error',
                    duration: 1000 * 5,
                    message: '服务器异常，请稍后再试!' + err
                  })
                })
              } else {
                done()
              }
            }
          }).then(() => {
          }).catch(() => {
            this.loading = false
            this.$message({
              type: 'info',
              message: '已取消审核'
            })
          })
        }
      },
      components: {
      }
    }
  </script>

  <style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
    .accountMar {
      .el-select .el-input {
        width: 110px;
      }
    }
  </style>
  


// WEBPACK FOOTER //
// src/page/financeMgr/checkRecord.vue